import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteMiscellaneousNews,
  getMiscellaneousNews,
  restoreMiscellaneousNews,
  updateMiscellaneousNews,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditMiscellaneousNews() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateMiscellaneousNews(
        id,
        title,
        description,
        image
      );
      if (result) {
        navigate("/miscellaneous-news/all");
      }
    } catch (error) {}
  };

  const publishMiscellaneousNews = async (id) => {
    try {
      await restoreMiscellaneousNews(id);

      navigate("/miscellaneous-news/all");
    } catch (error) {}
  };
  const unPublishMiscellaneousNews = async (id) => {
    try {
      await deleteMiscellaneousNews(id);

      navigate("/miscellaneous-news/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneMiscellaneousNews = async (id) => {
    try {
      const result = await getMiscellaneousNews(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.miscellaneousNewsId}
          breadCrumbLink={"Miscellaneous News"}
          breadCrumbText={"Edit News"}
          goBackLink={"/miscellaneous-news/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishMiscellaneousNews}
          unPublishItem={unPublishMiscellaneousNews}
          getOneItem={getOneMiscellaneousNews}
        />
      </Container>
    </>
  );
}
